import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Heading from 'components/shared/heading';
import Link from 'components/shared/link';

import styles from './reasons.module.scss';

import shape from './svg/shape.svg';

const cx = classNames.bind(styles);

const Reasons = ({ title, items, linktext = null, linkurl = null }) => (
  <section className={cx('wrapper')}>
    <div className={cx('container')}>
      <Heading
        className={cx('title')}
        tag="h2"
        size="xl"
        highlightedWordsWithoutWrap={false}
        innerHTML={title}
      />

      <ol className={cx('items-wrapper')}>
        {items.map(({ text }, index) => (
          <li className={cx('item')} key={index}>
            <Heading className={cx('item-text')} tag="p" size="md" innerHTML={text} />
          </li>
        ))}
      </ol>

      {linktext && linkurl && (
        <div className={cx('link-wrapper')}>
          <Link to={linkurl}>{linktext}</Link>
        </div>
      )}

      <img className={cx('shape')} src={shape} aria-hidden alt="" />
    </div>
  </section>
);

Reasons.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  linktext: PropTypes.string,
  linkurl: PropTypes.string,
};


export default Reasons;
